// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1-4zy","title":"Info_title__3BcFH","links":"Info_links__21ncS","link":"Info_link__1hc7W","logo":"Info_logo__2yuLb"};